/**
 * Bloggartikler for SEO-trafikk
 * Søkeord: SEO Oslo, nettside pris Norge, digital markedsføring Oslo
 */

export const blogPosts = [
  {
    slug: 'hva-koster-nettside-i-norge',
    title: 'Hva koster nettside i Norge? Komplett prisoversikt 2026',
    description: 'Få oversikt over nettsidepriser i Norge. Fra enkel presentasjonsside til nettbutikk – hva kan du forvente å betale? Side Kraft gir ærlige svar.',
    date: '2026-03-07',
    readTime: '5 min',
    keywords: 'nettside pris Norge, nettside kostnad, nettside pris Oslo',
    content: `
      <p>En av de vanligste spørsmålene vi får er: <strong>Hva koster en nettside i Norge?</strong> Svaret avhenger av mange faktorer. Her gir vi deg en ærlig oversikt.</p>

      <h2>Nettsidepriser – hva betaler du for?</h2>
      <p>En profesjonell nettside i Norge koster typisk mellom 15 000 og 150 000 kroner, avhengig av omfanget. En enkel presentasjonsside for en liten bedrift starter ofte rundt 20 000–40 000 kr. En nettbutikk eller mer avansert løsning kan koste 80 000 kr og oppover.</p>

      <h2>Faktorer som påvirker nettsidepris</h2>
      <ul>
        <li><strong>Antall sider</strong> – Flere sider betyr mer arbeid og høyere pris</li>
        <li><strong>Design</strong> – Skreddersydd design koster mer enn malbasert</li>
        <li><strong>Funksjonalitet</strong> – Kontaktskjema, booking, webshop øker prisen</li>
        <li><strong>SEO</strong> – Søkemotoroptimalisering inkludert gir bedre synlighet</li>
      </ul>

      <h2>Hvorfor investere i en profesjonell nettside?</h2>
      <p>En nettside er ofte det første potensielle kunder ser av bedriften din. En dårlig eller utdatert nettside kan koste deg kunder. En profesjonell nettside fra et byrå som Side Kraft er investert i fremtiden – den er mobilvennlig, rask og optimalisert for Google.</p>

      <p>Ønsker du en uforpliktende prisoverslag? <a href="/kontakt">Ta kontakt med Side Kraft</a> – vi gir deg et ærlig tilbud basert på behovene dine.</p>
    `,
  },
  {
    slug: 'hva-er-seo',
    title: 'Hva er SEO? Søkemotoroptimalisering forklart for norske bedrifter',
    description: 'Hva er SEO og hvorfor er det viktig for din bedrift? Side Kraft forklarer søkemotoroptimalisering på en enkel måte – og hvordan du får flere kunder fra Google.',
    date: '2026-03-07',
    readTime: '6 min',
    keywords: 'Hva er SEO, søkemotoroptimalisering, SEO Oslo',
    content: `
      <p><strong>SEO</strong> står for Search Engine Optimization – på norsk: <strong>søkemotoroptimalisering</strong>. Det handler om å gjøre nettsiden din synlig for folk som søker på Google.</p>

      <h2>Hvorfor er SEO viktig?</h2>
      <p>Over 90 % av alle søk i Norge skjer på Google. Hvis bedriften din ikke dukker opp når folk søker etter det du tilbyr, mister du kunder til konkurrentene. SEO hjelper deg å rangere høyere i søkeresultatene – og få mer organisk (gratis) trafikk.</p>

      <h2>Hva innebærer SEO?</h2>
      <ul>
        <li><strong>Teknisk SEO</strong> – Rask nettside, mobilvennlig, riktig struktur</li>
        <li><strong>Innhold</strong> – Relevante tekster med nøkkelord folk faktisk søker på</li>
        <li><strong>Lenker</strong> – Kvalitetslenker fra andre nettsider styrker din troverdighet</li>
      </ul>

      <h2>SEO Oslo – lokalt fokus</h2>
      <p>For bedrifter i Oslo og Østlandet er lokalt SEO spesielt viktig. Når noen søker «plumber Oslo» eller «digital markedsføring Oslo», vil Google vise bedrifter som er relevante for det området. Side Kraft hjelper norske bedrifter med å bli synlige i lokale søk.</p>

      <p>Vil du lære mer om hvordan SEO kan hjelpe din bedrift? <a href="/tjenester/seo">Les om våre SEO-tjenester</a> eller <a href="/kontakt">ta kontakt</a> for en uforpliktende samtale.</p>
    `,
  },
  {
    slug: 'hvordan-fa-flere-kunder-fra-google',
    title: 'Hvordan få flere kunder fra Google – 7 konkrete tips',
    description: 'Vil du få flere kunder fra Google uten å betale for annonser? Side Kraft gir deg 7 praktiske tips for organisk trafikk og bedre synlighet.',
    date: '2026-03-07',
    readTime: '7 min',
    keywords: 'flere kunder fra Google, organisk trafikk, digital markedsføring Oslo',
    content: `
      <p>Å få flere kunder fra Google uten å betale for annonser krever strategi og tålmodighet. Her er 7 konkrete tips som virker.</p>

      <h2>1. Optimaliser nettsiden din for søk</h2>
      <p>En nettside som er rask, mobilvennlig og har godt innhold rangerer bedre. Sørg for at titler, beskrivelser og overskrifter inneholder ord folk faktisk søker på.</p>

      <h2>2. Skriv innhold folk søker etter</h2>
      <p>Tenk på hva potensielle kunder søker på. «Nettside pris Norge», «SEO Oslo», «digital markedsføring» – skriv artikler og sider som svarer på disse spørsmålene.</p>

      <h2>3. Bruk Google Bedriftsprofil</h2>
      <p>En oppdatert Google Bedriftsprofil gjør at du dukker opp i lokale søk og på Google Maps. Legg inn åpningstider, bilder og beskrivelse.</p>

      <h2>4. Få lenker fra andre nettsider</h2>
      <p>Lenker fra Gulesider, Proff, bransjesider og blogger signaliserer til Google at siden din er troverdig. Registrer bedriften din på relevante steder.</p>

      <h2>5. Vær konsekvent</h2>
      <p>SEO tar tid – ofte 3–6 måneder før du ser tydelige resultater. Hold ut og fortsett å publisere nyttig innhold.</p>

      <h2>6. Mål resultatene</h2>
      <p>Bruk Google Analytics og Search Console for å se hva som fungerer. Juster strategien basert på data.</p>

      <h2>7. Få hjelp fra eksperter</h2>
      <p>Et digitalt byrå som Side Kraft kan spare deg for tid og feil. Vi har erfaring med å få norske bedrifter synlige på Google.</p>

      <p><a href="/kontakt">Ta kontakt med Side Kraft</a> for en gratis konsultasjon om hvordan vi kan hjelpe deg med mer trafikk fra Google.</p>
    `,
  },
  {
    slug: 'google-ads-tips',
    title: 'Google Ads tips – få mer ut av annonsebudsjettet ditt',
    description: '7 Google Ads-tips som gir bedre resultater. Lær hvordan du får flere kunder fra Google Ads med samme budsjett – fra Side Kraft.',
    date: '2026-03-07',
    readTime: '6 min',
    keywords: 'Google Ads tips, Google annonser, digital annonsering Oslo',
    content: `
      <p>Google Ads kan gi rask trafikk – men mange kaster bort penger på dårlig satt opp kampanjer. Her er våre beste tips for å få mer ut av annonsebudsjettet ditt.</p>

      <h2>1. Start med søkeannonser</h2>
      <p>Søkeannonser vises når folk aktivt søker etter det du tilbyr. Det gir ofte bedre konvertering enn display-annonser fordi brukeren allerede er i «kjøpsmodus».</p>

      <h2>2. Bruk negative nøkkelord</h2>
      <p>Ekskluder søkeord som ikke er relevante. Hvis du selger profesjonelle tjenester, ekskluder «gratis» og «billig» for å unngå klikk fra feil målgruppe.</p>

      <h2>3. Skriv gode annonsetekster</h2>
      <p>Inkluder nøkkelordet i overskriften. Bruk call-to-action som «Ring nå» eller «Få tilbud». Test ulike varianter for å se hva som fungerer best.</p>

      <h2>4. Bruk landingssider som matcher</h2>
      <p>Send brukere til en side som svarer på det de søkte på. En generell forsiden konverterer ofte dårligere enn en dedikert landingsside.</p>

      <h2>5. Sett opp konverteringssporing</h2>
      <p>Mål henvendelser, bestillinger eller oppgaver. Uten sporing vet du ikke om annonsene faktisk gir resultater.</p>

      <h2>6. Test og optimaliser</h2>
      <p>Google Ads krever kontinuerlig justering. Prøv ulike bud, nøkkelord og annonsetekster. Bruk data til å forbedre.</p>

      <h2>7. Kombiner med SEO</h2>
      <p>Google Ads gir rask trafikk. SEO gir langsiktig, gratis trafikk. Den beste strategien kombinerer begge – spesielt i starten mens du bygger opp organisk synlighet.</p>

      <p>Trenger du hjelp med Google Ads? <a href="/tjenester/annonsering">Side Kraft</a> hjelper norske bedrifter med målrettet digital annonsering. <a href="/kontakt">Ta kontakt</a> for en uforpliktende samtale.</p>
    `,
  },
  {
    slug: 'webutvikling-trender-2026',
    title: 'Webutvikling i 2026: Slik bygger du en nettside som vinner',
    description: 'Hva kreves av en moderne nettside i 2026? Fra AI-integrasjon til ekstrem hastighet – lær hvordan din bedrift kan ligge i forkant med Side Kraft.',
    date: '2026-03-09',
    readTime: '8 min',
    keywords: 'webutvikling norge, moderne nettside 2026, profesjonell webutvikler',
    content: `
      <p>I 2026 er ikke en nettside bare et digitalt visittkort – det er din viktigste ansatte. Her er trendene og kravene som definerer suksess i det norske markedet i år.</p>

      <h2>1. Kunstig Intelligens (AI) som standard</h2>
      <p>AI brukes nå til alt fra personlig tilpasning av innhold til avanserte chatbots som faktisk løser kundenes problemer. En moderne nettside bør utnytte disse verktøyene for å spare tid og øke konverteringen.</p>

      <h2>2. "Page Experience" er viktigere enn noen gang</h2>
      <p>Google har gjort brukeropplevelse til en av de viktigste rangeringsfaktorene. Dette betyr at siden din MÅ være lynrask, stabil og enkel å navigere på både mobil og desktop. Side Kraft fokuserer ekstremt mye på denne tekniske biten.</p>

      <h2>3. Minimalisme og visuell ro</h2>
      <p>Brukerne i 2026 er overveldet av informasjon. De beste nettsidene bruker nå mer "white space", store fonter og tydelige budskap. Profesjonell styling med avrundede former og myke skygger gir et premium inntrykk som skaper tillit.</p>

      <h2>Slik kommer du i gang</h2>
      <p>Vurderer du å fornye bedriftens nettside? <a href="/tjenester/nettside">Les om våre løsninger for nettsideutvikling</a> eller <a href="/kontakt">kontakt oss for en prat</a>.</p>
    `,
  },
  {
    slug: 'lokal-seo-for-smabedrifter',
    title: 'Lokal SEO: Slik får småbedrifter kunder uten annonsering',
    description: 'Eier du en lokal bedrift i Norge? Lokal SEO er den mest effektive måten å få kunder på uten å betale for annonser. Her er vår guide til suksess.',
    date: '2026-03-09',
    readTime: '6 min',
    keywords: 'lokal seo norge, google bedriftsprofil tips, få kunder lokalt',
    content: `
      <p>Mange småbedrifter tror de må bruke tusenvis av kroner på annonser for å bli sett. Sannheten er at <strong>Lokal SEO</strong> ofte gir bedre resultater helt gratis.</p>

      <h2>Hva er lokal SEO?</h2>
      <p>Når noen søker etter en tjeneste "nær meg" eller i en spesifikk by (f.eks. "elektriker Oslo" eller "frisør Bergen"), viser Google lokale resultater og kart. Å ligge på topp her er gull verdt.</p>

      <h2>Slik dominerer du lokalt:</h2>
      <ul>
        <li><strong>Google Bedriftsprofil:</strong> Dette er ditt viktigste verktøy. Sørg for at all info er korrekt og oppdatert.</li>
        <li><strong>Kundeanmeldelser:</strong> Ingenting selger bedre enn fornøyde kunder. Spør alltid etter en anmeldelse på Google!</li>
        <li><strong>Lokalt innhold:</strong> Skriv om ting som er relevante for din region på nettsiden din.</li>
      </ul>

      <p>Trenger du hjelp til å bli synlig på kartet? <a href="/tjenester/google-bedriftsprofil">Vi kan optimalisere din Google Bedriftsprofil</a>.</p>
    `,
  },
  {
    slug: 'konverteringsoptimalisering-tips',
    title: 'Konverteringsoptimalisering: Gjør besøkende til betalende kunder',
    description: 'Har du trafikk, men lite salg? Lær de hemmelige triksene bak konverteringsoptimalisering (CRO) som øker din bunnlinje uten mer trafikk.',
    date: '2026-03-09',
    readTime: '7 min',
    keywords: 'konverteringsoptimalisering, CRO tips, øke salg nettside',
    content: `
      <p>Har du mange besøkende på nettsiden, men telefonen ringer sjelden? Da har du et konverteringsproblem. Her er hvordan vi i Side Kraft hjelper våre kunder med å selge mer.</p>

      <h2>Hva er en konvertering?</h2>
      <p>En konvertering er når en besøkende gjør det du vil de skal gjøre – f.eks. fyller ut et kontaktskjema, ringer deg eller kjøper et produkt i nettbutikken.</p>

      <h2>Tips for høyere konvertering:</h2>
      <ul>
        <li><strong>Tydelige knapper (CTA):</strong> Bruk knapper som skiller seg ut. "Bestill gratis befaring" er bedre enn bare "Kontakt".</li>
        <li><strong>Fjern unødvendig støy:</strong> Ikke la kunden lure på hva de skal gjøre. Led dem rett til målet.</li>
        <li><strong>Bruk "Social Proof":</strong> Vis frem logoer til kunder du har hjulpet og anmeldelser fra fornøyde brukere.</li>
      </ul>

      <p>Vi i Side Kraft bygger alle våre nettsider med fokus på konvertering. <a href="/prosjekter">Se våre tidligere prosjekter her</a> for inspirasjon.</p>
    `,
  },
  {
    slug: 'b2b-markedsforing-norge',
    title: 'B2B Markedsføring: Slik tiltrekker du profesjonelle kunder digitalt',
    description: 'Selger du tjenester eller produkter til andre bedrifter? B2B-markedsføring krever en annen tilnærming. Lær hvordan du bygger autoritet og fanger Leads.',
    date: '2026-03-12',
    readTime: '10 min',
    keywords: 'B2B markedsføring norge, profesjonelle kunder, digital strategi bedrift',
    content: `
      <p>Markedsføring mot andre bedrifter (B2B) handler om mer enn bare synlighet – det handler om <strong>tillit</strong> og <strong>autoritet</strong>. Profesjonelle kunder kjøper sjelden på impuls; de kjøper løsninger som løser deres problemer.</p>

      <h2>1. Fra "Push" til "Pull" med innholdsmarkedsføring</h2>
      <p>I B2B-verdenen er kundene dine eksperter i sitt felt. De gjennomskuer billige salgtriks. For å tiltrekke deg profesjonelle kunder må du vise at du er en autoritet gjennom dype artikler, casestudier og hvitbøker.</p>

      <h2>2. LinkedIn og Google – de to viktigste kanalene</h2>
      <p>Mens Facebook kan være bra for B2C, er LinkedIn og Google bærebjelkene i B2B. Google Ads rettet mot spesifikke problemstillinger og en sterk organisk tilstedeværelse (SEO) sikrer at du er der når beslutningstakerne leter etter svar.</p>

      <h2>3. Langsiktige relasjoner og lead-generering</h2>
      <p>B2B-salgssykluser kan ta måneder. Nettsiden din må være rigget for å fange opp kontakinformasjon (leads) tidlig, slik at du kan pleie relasjonen over tid. Tydelige kontaktskjemaer og verdiøkende innhold er nøkkelen.</p>

      <p>Side Kraft hjelper bedrifter med å sette opp strategiske B2B-løsninger. <a href="/kontakt">Ta kontakt for en strategisk samtale</a> om hvordan vi kan hjelpe din bedrift å vokse.</p>
    `,
  },
];

export function getPostBySlug(slug) {
  return blogPosts.find((p) => p.slug === slug);
}

export function getAllSlugs() {
  return blogPosts.map((p) => p.slug);
}
